//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import _ from "lodash";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Symp_itemIpad from "./Symp_itemIpad";
import { postureSympIpad} from "../assets/lang.conf/root";
export default {
  name: "Posture_sympipad",
  directive: {
    bModalDirective
  },
  components: {
    Symp_itemIpad
  },
  props: ["severeRisks", "mildRisks", "normalRisks"],
  i18n: {
    // `i18n` option, setup locale info for component
    messages: {
      ...postureSympIpad
    }
  },
  data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      },
      tips: {
        riskCount: 0,
        riskTip: "风险"
      },
      isShow: false,
      riskLevelList: [],
      hClass: false,
      mClass: false,
      nClass: false,
      classleve: "normal",
      ntips: {
        tip: "正常"
      },
      mtips: {
        tip: "潜在风险"
      }
    };
  },
  computed: {},
  methods: {
    getRiskImg(risk) {
      let direction = "normal";
      let img;
      console.log(risk.key);
      if (
        !_.isNull(risk.direction) &&
        risk.key !== "legO" &&
        risk.key !== "legX" &&
        risk.key !== "legXO" &&
        risk.key !== "kneeOverstretch"
      ) {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    setModalInfo(risk) {
      this.$emit("setModalInfo", risk);
    }
  },
  created() {
    let riskTips = {},
      riskCount = 0,
      riskTip = "";

    if (this.severeRisks.length > 0) {
      riskCount = this.severeRisks.length;
      riskTip = "高风险";
      this.isShow = true;
      this.hClass = true;
      riskTips.tip = riskTip;
      this.classleve = "severe";
      this.riskLevelList = this.severeRisks;
    } else if (this.mildRisks.length > 0) {
      riskCount = this.mildRisks.length;
      riskTip = "潜在风险";
      this.isShow = false;
      this.mClass = true;
      riskTips.tip = riskTip;
      this.classleve = "mild";
      this.riskLevelList = this.mildRisks;
    } else {
      riskCount = this.normalRisks.length;
      riskTip = "风险";
      this.isShow = false;
      this.nClass = true;
    }
    riskTips.riskCount = riskCount;
    riskTips.riskTip = riskTip;
    this.tips = Object.assign({}, riskTips);
    console.log("this.riskTipsddddddddddddddddd:", this.tips);
  }
};



// WEBPACK FOOTER //
// ./src/components/Posture_sympipad.vue